var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostHeartLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3597 0.772461H19.2968C16.8012 0.772461 14.5947 1.8107 13.3248 3.34334C12.055 1.8107 9.84849 0.772461 7.35282 0.772461H7.28996C3.39872 0.802125 0.249268 3.28895 0.249268 6.35918C0.249268 8.18845 1.26765 10.7841 3.25413 12.9199C7.0385 16.9888 13.3248 20.5484 13.3248 20.5484C13.3248 20.5484 19.6112 16.9888 23.3955 12.9199C25.382 10.7841 26.4004 8.18845 26.4004 6.35918C26.4004 3.28895 23.2509 0.802125 19.3597 0.772461Z",
    fill: "#156563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostHeartLike);
export default __webpack_public_path__ + "static/media/PostHeartLike.1278637fa9c6edd4d7bc300e51a13197.svg";
export { ForwardRef as ReactComponent };